import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import DonutChart from 'front-onceforall-core/dist/components/charts/DonutChart';
import Loading from './loading';

function DocumentsStatsView(props) {
  const percentages = props.error ?
    <Translate
      value={props.error}
      tag="div"
    /> :
    <>
      <div className="percentages-legend mb-5">
        {props.data.map((item, index) => (
          <div
            key={`document-chart-data-${index}`}
            className="item"
          >
            <span
              className="bullet"
              style={{color: item.stroke}}
            />
            <span className="label"><Translate value={item.label}/></span>
            <span className="percentage">{item.value}%</span>
          </div>
        ))}
      </div>
      {props.actions}
    </>;

  return (
    <div className="card mb-3 h-100">
      <div className="row">
        {props.loading ?
          <Loading actions={props.actions}/> :
          <>
            <div className="col-12 col-md-6">
              <div className="card-header">
                <div className="card-title">
                  <Translate value={props.title}/>
                </div>
              </div>
              {percentages}
            </div>
            <div className="col-12 col-md-6 flex-container column center">
              {!props.error &&
                <DonutChart
                  data={props.data}
                  mainPercentageLabel={<Translate value="globalDashboard.documentsStillValid"/>}
                />
              }
            </div>
          </>
        }
      </div>
    </div>
  );
}

DocumentsStatsView.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  title: PropTypes.string.isRequired
};

export default DocumentsStatsView;
